import React, { useState } from "react";
import { Box, IconButton, TableCell, TableRow } from "@material-ui/core";
import { DPProviderBankAccount } from "Shared/types/BankAccounts";
import useStyles from "./styles";
import pretty from "Shared/pretty";
import VisibilityOnIcon from "@material-ui/icons/VisibilityRounded";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOffRounded";
import { DPPermissionGate } from "Components/DP";

export interface ProviderBankAccountRowProps {
  providerBankAccount: NonNullable<DPProviderBankAccount>;
  note: string;
}

const ProviderBankAccountRow = ({
  providerBankAccount,
  note,
}: ProviderBankAccountRowProps) => {
  const {
    createdAt,
    accountNumber,
    routingNumber,
  } = providerBankAccount;
  const [showAccount, setShowAccount] = useState(false);
  const classes = useStyles();
  const toggleVisibility = () => {
    setShowAccount(!showAccount);
  };
  return (
    <TableRow>
      <TableCell align="right">
        {createdAt ? pretty.date(createdAt) : ""}
      </TableCell>
      <TableCell align="right">
        <Box justifyContent="flex-end">
          {showAccount ? accountNumber : pretty.account(accountNumber)}
          <DPPermissionGate permissionKeys={["canShowBankAccounts"]}>
            <IconButton
              disableRipple={true}
              disableFocusRipple={true}
              size="small"
              color="inherit"
              aria-label="View"
              onClick={toggleVisibility}
            >
              {showAccount ? (
                <VisibilityOffIcon className={classes.icon} />
              ) : (
                <VisibilityOnIcon className={classes.icon} />
              )}
            </IconButton>
          </DPPermissionGate>
        </Box>
      </TableCell>
      <TableCell align="right">{routingNumber}</TableCell>
      <TableCell>{note}</TableCell>
    </TableRow>
  );
};

export default ProviderBankAccountRow;
